module.exports = __webpack_public_path__ + "img/dc91606.svg";